import { render, staticRenderFns } from "./AboutCardTbByAlfa.vue?vue&type=template&id=54bfa9e8"
import script from "./AboutCardTbByAlfa.vue?vue&type=script&lang=js"
export * from "./AboutCardTbByAlfa.vue?vue&type=script&lang=js"
import style0 from "../about-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports